const api = require('./api-caller')
const baseEndpoint = '/certificates'

module.exports = {
  getCertificate: (id) => {
    const endpoint = `${baseEndpoint}/${id}`
    return api(endpoint, 'GET')
  }
}
